<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工：">
          <el-select v-model="formInline.userKeyId" placeholder="请选择人员" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in userList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：">
          <el-date-picker v-model="dateStr" type="month" value-format="yyyy-MM" size="small" :clearable="false"
            @change="handleDateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/monthSalary/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" :loading="loading">
        <el-table-column align="center" slot="yearMonth" label="年月" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.year }}年{{ scope.row.month }}月
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
  </div>
</template>

<script>
import {
  GetUserMonthSalaryPageList
} from "@/api/salaryApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import {
  GetUserBindSelectByPermission
} from "@/api/userApi.js";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "考勤记录",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      dateStr: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 15,
        storeKeyId: "",
        userKeyId: "",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      },
      storeList: [],
      userList: [],
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          slot: "yearMonth",
          label: "年月",
          isKeep: true,
          minWidth: "120",
          align: "center",
          fixed: "left",
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          minWidth: "120",
          align: "center",
          fixed: "left",
        },
        {
          slot: "userInfo.chName",
          label: "员工姓名",
          width: "100",
          align: "center",
          fixed: "left",
        },
        {
          prop: "postName",
          label: "岗位",
          width: "110",
          align: "center",
          fixed: "left",
        },
        {
          prop: "baseSalary",
          label: "基础薪资",
          width: "100",
          align: "center",
        },
        {
          prop: "perfectAttendance",
          label: "全勤",
          width: "100",
          align: "center",
        },
        {
          prop: "postWage",
          label: "岗位薪资",
          width: "100",
          align: "center",
        },
        {
          prop: "socialSecuritySubsidy",
          label: "社保补贴",
          width: "100",
          align: "center",
        },
        {
          prop: "seniorityPay",
          label: "工龄补贴",
          width: "100",
          align: "center",
        },
        {
          prop: "requiredAttendance",
          label: "应出勤天数",
          width: "120",
          align: "center",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "170",
          align: "center",
        },
        {
          prop: "editor",
          label: "维护人",
          width: "120",
          align: "center",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          width: "170",
          align: "center",
        },
      ],
    };
  },
  // 注册组件
  components: {

  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetOrgInfoListByConfig();
    this.GetUserBindSelectByPermission();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 获取人员信息绑定下拉框_根据权限
    GetUserBindSelectByPermission() {
      const paramer = {};
      GetUserBindSelectByPermission(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.userList = [];
            if (res.code == 1) {
              this.userList = res.data;
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取人员信息失败!");
        });
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetUserMonthSalaryPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 日期选择器事件
    handleDateChange(val) {
      if (val.length > 0) {
        var list = val.split('-');
        this.formInline.year = parseInt(list[0]);
        this.formInline.month = parseInt(list[1]);
      } else {
        this.formInline.year = new Date().getFullYear();
        this.formInline.month = new Date().getMonth() + 1;
      }
      this.getListData();
    },
  },
};
</script>

<style scoped></style>